import { type JSX } from "react";

import { Autocomplete as BaseAutocomplete } from "@base-ui/react/autocomplete";
import { useFloatingPortalContainer } from "@frontend/contexts";

import type { AutocompletePortalProps } from "./Autocomplete.types";

export function AutocompletePortal({
  children,
  ...props
}: AutocompletePortalProps): JSX.Element {
  const container = useFloatingPortalContainer();

  return (
    <BaseAutocomplete.Portal container={container} {...props}>
      {children}
    </BaseAutocomplete.Portal>
  );
}
